import registrationInstance from '../instance'

const getUsersPinCode = (pinCode) => {
  return registrationInstance.get(`/userPinCodes/${pinCode}`)
}

export default getUsersPinCode
